import { render, staticRenderFns } from "./oma.vue?vue&type=template&id=24e6796e&scoped=true"
import script from "./oma.vue?vue&type=script&lang=js"
export * from "./oma.vue?vue&type=script&lang=js"
import style0 from "./oma.vue?vue&type=style&index=0&id=24e6796e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e6796e",
  null
  
)

export default component.exports